module.exports = __webpack_public_path__ + "static/img/sport.f44520c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/sport.png
// module id = J09p
// module chunks = 1